// extracted by mini-css-extract-plugin
export var gif = "_ca-0";